<template>
    <div class="compatibility_page page">
        <div class="top_bg">
            <!--      <img src="../assets/compatibility_bg.png">-->
            <img :src="banner?api+banner:require('../assets/download_bg.png')">
        </div>

        <b-container class="compatibility_content my_content">
            <p class="title">{{ title }}</p>
            <b-row class="select_box">
                <b-col sm="12" md="4">
                    <b-form-select v-model="select1" :options="options1" @change="select1Change()"></b-form-select>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-select v-model="select2" :options="options2" @change="select2Change()"></b-form-select>
                </b-col>
                <b-col sm="12" md="4">
                    <b-form-select v-model="select3" :options="options3" @change="select3Change()"></b-form-select>
                </b-col>
            </b-row>

            <p class="result_title">{{ languageNum == 3 ? '查询兼容结果' : 'Result' }}</p>

            <b-row class="result_box">
                <b-col md="3" v-for="item in resultList" :key="item.id" class="item"
                       @click="$router.push('/product/detail?id=' + item.id)">
                    <div class="img_obx">
                        <img :src="api+item.background">
                    </div>
                    <p class="name clamp2" style="margin-top: 16px">{{ item.name }}</p>
                </b-col>

            </b-row>

        </b-container>

    </div>
</template>

<script>

    import {getTypeList, getCompatibleBrand, getCompatibleModel} from '../api/HomeService'
    import {api} from '../api/api';


    export default {
        name: "Compatibility",
        data() {
            return {
                languageNum: window.localStorage.getItem("languageNum"),
                resultList: [],
                title: '',
                select1: null,
                select2: null,
                select3: null,
                options1: [],
                options2: [],
                options3: [],
                banner: '',
                api: api
            }
        },
        methods: {
            select3Change() {
                console.log(this.select3)

                for (let i = 0; i < this.options3.length; i++) {
                    if (this.options3[i].id == this.select3) {
                        this.resultList = this.options3[i].lexarGoodsList;
                        break
                    }
                }


            },

            select2Change() {
                this.options3 = [
                    {value: null, text: this.languageNum == 3 ? '请选择型号' : 'model'},
                ];
                let sendData = {
                    languageNum: this.languageNum,
                    compatibleId: this.select2
                }

                getCompatibleModel(sendData, data => {
                    for (let i = 0; i < data.length; i++) {
                        data[i].text = data[i].name
                        data[i].value = data[i].id
                        this.options3.push(data[i])
                    }
                    // this.resultList = data
                })
            },


            select1Change() {
                this.options2 = [
                    {value: null, text: this.languageNum == 3 ? '请选择品牌' : 'brand'},
                ];
                this.options3 = [
                    {value: null, text: this.languageNum == 3 ? '请选择型号' : 'model'},
                ];

                let sendData = {
                    languageNum: this.languageNum,
                    typeId: this.select1
                }

                getCompatibleBrand(sendData, data => {
                    for (let i = 0; i < data.length; i++) {
                        data[i].text = data[i].name
                        data[i].value = data[i].id
                        this.options2.push(data[i])
                    }
                })
            },

            getTypeList() {
                let sendData = {
                    languageNum: this.languageNum,
                    classType: 5
                }
                getTypeList(sendData, data => {
                    for (let i = 0; i < data.length; i++) {
                        data[i].text = data[i].name
                        data[i].value = data[i].id
                        this.options1.push(data[i])
                    }
                })
            }
        },
        mounted() {

            let menuList = JSON.parse(window.localStorage.getItem('menuList'));
            console.log(menuList)
            for (let i = 0; i < menuList.length; i++) {
                if (menuList[i].children) {
                    for (let j = 0; j < menuList[i].children.length; j++) {
                        if (this.$route.path.indexOf(menuList[i].children[j].menuUrl) > 0) {
                            this.title = menuList[i].children[j].title
                            this.banner = menuList[i].children[j].banner
                        }
                    }
                }
            }

            this.languageNum = window.localStorage.getItem("languageNum");
            this.options1 = [
                {value: null, text: this.languageNum == 3 ? '请选择装置类型' : 'type'},
            ];
            this.options2 = [
                {value: null, text: this.languageNum == 3 ? '请选择品牌' : 'brand'},
            ];
            this.options3 = [
                {value: null, text: this.languageNum == 3 ? '请选择型号' : 'model'},
            ]

            this.getTypeList();
        }
    }
</script>

<style scoped lang="scss" src="../css/compatibility.scss">

</style>